<template lang="pug">
    .b2b-page-ocr-document
      ods-module.box-card
        div(slot='header')
          ods-row.info(type='flex', align='middle')
            ods-col(:span='8')
              div {{ $t('ocr.title_ocr_document_validation_page') }}
            ods-col(:span='16')
              ods-row(type='flex', justify='end')
                ods-tooltip(:content='$t("ocr.buttons.reject")', placement='bottom')
                  ods-button(
                    v-if='ocrDocumentForm.id && ocrDocumentForm.statusDocument === "PENDING_OF_VALIDATION"',
                    icon='ods-icon-disable',
                    type='primary',
                    circle,
                    size='small',
                    :disabled='ocrDocumentForm.isLocked'
                    @click.native='isShowDialogRejectedInvoice = true')
                    | {{ $t('ocr.buttons.reject') }}
                ods-tooltip(:content='$t("ocr.buttons.approve")', placement='bottom')
                  ods-button(
                    v-if='ocrDocumentForm.id && ocrDocumentForm.statusDocument === "PENDING_OF_VALIDATION"',
                    icon='ods-icon-tick-large',
                    type='primary',
                    size='small',
                    :disabled='ocrDocumentForm.isLocked'
                    circle,
                    @click.native="sendDocument('APPROVE')")
                    | {{ $t('ocr.buttons.approve') }}
        ods-row(type='flex')
          ods-col.leftColumn_pdf_viewer(:span='12')
            //- Visualizador de PDF
            PDFViewer(:source="pdfDocument",
              ref="pdfViewer",
              :settings="{ defaultZoom: 175 }",
              :controls="['print', 'rotate', 'zoom', 'catalog', 'switchPage']",
              style="height: 100%; width: 100%;")
          ods-col.rightColumn_data(:span='12')
            ods-row.label-info(type='flex')
              ods-form-item__label(:span='24' v-if="ocrDocumentForm.isLocked")
                | {{ $t('ocr.document_block_label_info') }}
            ods-form(
              ref='ocrDocumentForm',
              :model='ocrDocumentForm',
              :rules='ocrDocumentFormRules',
              label-width='14rem',
              label-position='top',
              size='small',
              status-icon)
              ods-row.form-title(type='flex')
                ods-form-item__label(:span='24')
                  | {{ $t('ocr.detail_form.general_data') }}
              ods-row.form-standard(type='flex')
                ods-col(:span='6')
                  ods-form-item.form-standard(
                    prop='invoiceNumber',
                    :label='$t("ocr.detail_form.invoiceNumber")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked'
                      v-model='ocrDocumentForm.invoiceNumber')
                ods-col(:span='6')
                  ods-form-item.form-center-left(
                    prop='invoiceSeriesCode',
                    :label='$t("ocr.detail_form.invoiceSeriesCode")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked'
                      v-model='ocrDocumentForm.invoiceSeriesCode')
                ods-col(:span='6')
                  ods-form-item.form-center-right(
                    prop='invoiceDate',
                    :label='$t("ocr.detail_form.invoiceDate")')
                    ods-date-picker(
                      v-model='ocrDocumentForm.invoiceDate',
                      type='date',
                      :format='$t("date_format_calendar")',
                      :disabled='ocrDocumentForm.isLocked',
                      prefix-icon='prefix-icon-date-time-picker',
                      :placeholder='$t("msg_generics.placeholder.datepicker")')
                ods-col(:span='6')
                  ods-tooltip(:content='$t("ocr.detail_form.invoiceType_ocrValue") + invoiceType_ocrValue', placement='top')
                    ods-form-item.form-standard(
                      prop='invoiceType',
                      :label='$t("ocr.detail_form.invoiceType")')
                      ods-select(
                        v-model='ocrDocumentForm.invoiceType',
                        :disabled='ocrDocumentForm.isLocked',
                        :placeholder='$t("ocr.select_placeholder")',
                        filterable)
                        ods-option(
                          v-for='documentType in optionsDocumentTypes',
                          :key='documentType.id',
                          :label='$t("ocr.document_class." + documentType.type)',
                          :value='documentType.id')
              ods-row.form-standard(type='flex')
                ods-col(:span='8')
                  ods-form-item.form-standard(
                    prop='correctiveInvoiceId',
                    :label='$t("ocr.detail_form.correctiveInvoiceId")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.correctiveInvoiceId')
                ods-col(:span='8')
                  ods-form-item.form-middle(
                    prop='deliveryDate',
                    :label='$t("ocr.detail_form.deliveryDate")')
                    ods-date-picker(
                      v-model='ocrDocumentForm.deliveryDate',
                      :disabled='ocrDocumentForm.isLocked',
                      type='date',
                      :format='$t("date_format_calendar")',
                      prefix-icon='prefix-icon-date-time-picker',
                      :placeholder='$t("msg_generics.placeholder.datepicker")')
                ods-col(:span='8')
                  ods-form-item.form-standard(
                    prop='purchaseOrder',
                    :label='$t("ocr.detail_form.purchaseOrder")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.purchaseOrder')
              ods-row.form-title(type='flex')
                ods-form-item__label(:span='24')
                  | {{ $t('ocr.detail_form.supplier_data') }}
              ods-row.form-standard(type='flex')
                ods-col(:span='11')
                  ods-form-item.form-standard(
                    prop='supplierTaxId',
                    :label='$t("ocr.detail_form.supplierTaxId")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.supplierTaxId')
                ods-col(:span='1')
                ods-col(:span='12')
                  ods-form-item.form-standard(
                    prop='supplierName',
                    :label='$t("ocr.detail_form.supplierName")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.supplierName')
              ods-row.form-standard(type='flex')
                ods-col(:span='24')
                  ods-form-item.form-standard(
                    prop='supplierAddress',
                    :label='$t("ocr.detail_form.supplierAddress")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.supplierAddress')
              ods-row.form-standard(type='flex')
                ods-col(:span='11')
                  ods-form-item.form-standard(
                    prop='supplierIban',
                    :label='$t("ocr.detail_form.supplierIban")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.supplierIban')
                ods-col(:span='1')
                ods-col(:span='12')
                  ods-form-item.form-standard(
                    prop='supplierEmail',
                    :label='$t("ocr.detail_form.supplierEmail")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.supplierEmail')
              ods-row.form-title(type='flex')
                ods-form-item__label(:span='24')
                  | {{ $t('ocr.detail_form.receiver_data') }}
              ods-row.form-standard(type='flex')
                ods-col(:span='8')
                  ods-form-item.form-standard(
                    prop='receiverTaxId',
                    :label='$t("ocr.detail_form.receiverTaxId")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.receiverTaxId')
                ods-col(:span='8')
                  ods-form-item.form-middle(
                    prop='receiverName',
                    :label='$t("ocr.detail_form.receiverName")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.receiverName')
                ods-col(:span='8')
                  ods-form-item.form-standard(
                    prop='buyerCentreCode',
                    :label='$t("ocr.detail_form.buyerCentreCode")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.buyerCentreCode')
              ods-row.form-standard(type='flex')
                ods-col(:span='24')
                  ods-form-item.form-standard(
                    prop='receiverAddress',
                    :label='$t("ocr.detail_form.receiverAddress")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.receiverAddress')
              ods-row.form-title(type='flex')
                ods-form-item__label(:span='24')
                  | {{ $t('ocr.detail_form.total_data') }}
              ods-row.form-standard(type='flex')
                ods-col(:span='11')
                  ods-form-item.form-standard(
                    prop='netAmount',
                    :label='$t("ocr.detail_form.netAmount")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.netAmount')
                ods-col(:span='1')
                ods-col(:span='12')
                  ods-form-item.form-standard(
                    prop='totalTaxAmount',
                    :label='$t("ocr.detail_form.totalTaxAmount")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.totalTaxAmount')
              ods-row.form-standard(type='flex')
                ods-col(:span='11')
                  ods-form-item.form-standard(
                    prop='totalAmount',
                    :label='$t("ocr.detail_form.totalAmount")')
                    ods-input(
                      :disabled='ocrDocumentForm.isLocked',
                      v-model='ocrDocumentForm.totalAmount')
                ods-col(:span='1')
                ods-col(:span='12')
                  ods-form-item.form-standard(
                    :label='$t("ocr.detail_form.currency")',
                    prop='currency')
                    ods-select(
                      v-model='ocrDocumentForm.currency',
                      :disabled='ocrDocumentForm.isLocked',
                      filterable)
                      ods-option(
                        v-for='currency in optionsCurrency',
                        :key='currency.id',
                        :label='$t("currency." + currency.code)',
                        :value='currency.id')
              ods-row.form-title(type='flex')
                ods-form-item__label(:span='24')
                  | {{ $t('ocr.detail_form.taxes') }}
              ods-row.form-title(type='flex')
                //- Tabla tasas/impuestos (ocr_document_tax)
                ods-table(
                  v-if='dataOcrTaxes.length > 0 ',
                  :data='dataOcrTaxes',
                  :default-sort="{ prop: 'id', order: 'ascending' }",
                  style='width: 100%',
                  @cell-mouse-enter='handleCellMouseEnterOcrTax',
                  highlight-current-row,
                  size='mini',
                  fit)
                  ods-table-column(
                    prop='attachmentName',
                    :label='$t("ocr.taxes_table.amount")',
                    :show-overflow-tooltip='true',
                    sortable='')
                    template(slot-scope='scope')
                      ods-input(
                        v-model='scope.row.amount'
                        :disabled='ocrDocumentForm.isLocked',
                        @blur="onNumberInput(scope.row, 'amount')"
                      )
                  ods-table-column(
                    prop='attachmentName',
                    :label='$t("ocr.taxes_table.categoryCode")',
                    :show-overflow-tooltip='true',
                    sortable='')
                    template(slot-scope='scope')
                      ods-select(
                        v-model="scope.row.categoryCode",
                        :disabled='ocrDocumentForm.isLocked',
                        :placeholder='$t("ocr.select_placeholder")',
                        filterable)
                        ods-option(
                          :id='tax.id',
                          v-for='tax in optionsInvoiceLineTax',
                          :key='tax.id',
                          :label='$t("adminTaxes.tax." + tax.categoryCode)',
                          :value='tax.id')
                  ods-table-column(
                    prop='attachmentName',
                    :label='$t("ocr.taxes_table.taxRate")',
                    :show-overflow-tooltip='true',
                    sortable='')
                    template(slot-scope='scope')
                      ods-input(
                        :disabled='ocrDocumentForm.isLocked',
                        v-model='scope.row.taxRate'
                        @blur="onNumberInput(scope.row, 'taxRate')"
                      )
                  ods-table-column(
                    prop='attachmentName',
                    :label='$t("ocr.taxes_table.taxAmount")',
                    :show-overflow-tooltip='true',
                    sortable='')
                    template(slot-scope='scope')
                      ods-input(
                        :disabled='ocrDocumentForm.isLocked',
                        v-model='scope.row.taxAmount'
                        @blur="onNumberInput(scope.row, 'taxAmount')"
                      )
                  ods-table-column(
                    width='80')
                    template(slot-scope='scope')
                      //- Botón eliminar impuesto/tasa
                      ods-tooltip(:content='$t("buttons.btnDelete")', placement='bottom')
                        ods-button(
                          type='neutral',
                          :disabled='ocrDocumentForm.isLocked',
                          @click='removeOcrDocumentTax(scope.row)')
                          ods-icon(name='close', size='16')
              ods-row.form-title(type='flex', style='justify-content: flex-end')
                ods-tooltip(:content='$t("party_detail.buttons.add_contact_data")', placement='bottom')
                  //- Botón añadir impuesto/tasa
                  ods-button.button-add-tax(
                    :disabled='ocrDocumentForm.isLocked',
                    icon='ods-icon-plus',
                    size='small',
                    circle,
                    @click.native='addOcrDocumentTax()')
                    | {{ $t('party_detail.buttons.add_contact_data') }}

      ods-row.form-actions()
        //- ods-col(:span='24')
          ods-tooltip(:content='$t("buttons.btnSaveChanges_tooltip")', placement='bottom')
            ods-button(
              type='primary',
              size='large'
              @click='addOrUpdateCentreApprovalAmount("ocrDocumentForm")')
              | {{ $t('buttons.btnSaveChanges') }}
          ods-tooltip(:content='$t("buttons.btnCancel")', placement='bottom')
            ods-button(
              ref='buttonCancel',
              type='neutral',
              size='large'
              @click='cancelOcrDocumentForm')
              | {{ $t('buttons.btnCancel') }}

        ods-module.collapse
          ods-accordion(v-model='activateModuleAttachment', @change='')
            ods-accordion-item(name='1')
              template(slot='title')
                span {{ $t('ocr.ocr_lines') }}
                span.info(v-show='!dataOcrLines.length') {{ $t('ocr.no_ocr_lines_data') }}

              //- Tabla líneas del documento (ocr_document_line)
              ods-table(
                v-if='dataOcrLines.length > 0 ',
                :data='dataOcrLines',
                :default-sort="{ prop: 'id', order: 'ascending' }",
                style='width: 100%',
                @cell-mouse-enter='handleCellMouseEnterOcrLine',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='attachmentName',
                  :label='$t("ocr.lines_table.productCode")',
                  :show-overflow-tooltip='true',
                  sortable='')
                  template(slot-scope='scope')
                      ods-input(
                        :disabled='ocrDocumentForm.isLocked',
                        v-model='scope.row.productCode')
                ods-table-column(
                  prop='attachmentName',
                  :label='$t("ocr.lines_table.description")',
                  :show-overflow-tooltip='true',
                  sortable='')
                  template(slot-scope='scope')
                      ods-input(
                        :disabled='ocrDocumentForm.isLocked',
                        v-model='scope.row.description')
                ods-table-column(
                  prop='attachmentName',
                  :label='$t("ocr.lines_table.quantity")',
                  :show-overflow-tooltip='true',
                  sortable='')
                  template(slot-scope='scope')
                      ods-input(
                        v-model='scope.row.quantity'
                        :disabled='ocrDocumentForm.isLocked',
                        @blur="onNumberInput(scope.row, 'quantity')"
                      )
                ods-table-column(
                  prop='attachmentName',
                  :label='$t("ocr.lines_table.unit")',
                  :show-overflow-tooltip='true',
                  sortable='')
                  template(slot-scope='scope')
                    ods-select(
                      v-model="scope.row.unit",
                      :disabled='ocrDocumentForm.isLocked',
                      :placeholder='$t("ocr.select_placeholder")',
                      filterable)
                      ods-option(
                        :id='unit.id',
                        v-for='unit in optionsUnitsOfMeasure',
                        :key='unit.id',
                        :label='$t("unit_of_measure." + unit.code)',
                        :value='unit.id')
                ods-table-column(
                  prop='attachmentName',
                  :label='$t("ocr.lines_table.unitPrice")',
                  :show-overflow-tooltip='true',
                  sortable='')
                  template(slot-scope='scope')
                      ods-input(
                        v-model='scope.row.unitPrice'
                        :disabled='ocrDocumentForm.isLocked',
                        @blur="onNumberInput(scope.row, 'unitPrice')"
                      )
                ods-table-column(
                  prop='attachmentName',
                  :label='$t("ocr.lines_table.amount")',
                  :show-overflow-tooltip='true',
                  sortable='')
                  template(slot-scope='scope')
                      ods-input(
                        v-model='scope.row.amount'
                        :disabled='ocrDocumentForm.isLocked',
                        @blur="onNumberInput(scope.row, 'amount')"
                      )
                ods-table-column(
                  prop='attachmentName',
                  :label='$t("ocr.lines_table.purchaseOrder")',
                  :show-overflow-tooltip='true',
                  sortable='')
                  template(slot-scope='scope')
                      ods-input(
                        :disabled='ocrDocumentForm.isLocked',
                        v-model='scope.row.purchaseOrder')
                ods-table-column(
                  width='80')
                  template(slot-scope='scope')
                    //- Botón eliminar línea
                    ods-tooltip(:content='$t("buttons.btnDelete")', placement='bottom')
                      ods-button(
                        type='neutral',
                        :disabled='ocrDocumentForm.isLocked',
                        @click='removeOcrDocumentLine(scope.row)')
                        ods-icon(name='close', size='16')
              ods-tooltip(:content='$t("party_detail.buttons.add_contact_data")', placement='bottom')
                //- Botón añadir línea
                ods-button.button-collapse(
                  icon='ods-icon-plus',
                  size='small',
                  :disabled='ocrDocumentForm.isLocked',
                  circle,
                  @click.native='addOcrDocumentLine()')
                  | {{ $t('party_detail.buttons.add_contact_data') }}

          ods-accordion(v-model='activateModuleAttachment', @change='')
            ods-accordion-item(name='2')
              template(slot='title')
                span {{ $t('ocr.ocr_attachment') }}
                span.info(v-show='!dataOcrAttachment.length') {{ $t('ocr.no_ocr_attachment_data') }}

              //- Tabla adjuntos (ocr_document_email_attachment)
              ods-table(
                v-if='dataOcrAttachment.length > 0 ',
                :data='dataOcrAttachment',
                :default-sort="{ prop: 'id', order: 'ascending' }",
                style='width: 100%',
                @cell-mouse-enter='handleCellMouseEnterOcrAttachment',
                highlight-current-row,
                size='mini',
                fit)
                ods-table-column(
                  prop='attachmentName',
                  :label='$t("ocr.attachments_table.filename")',
                  :show-overflow-tooltip='true',
                  sortable='')
                ods-table-column(
                  prop='size',
                  :label='$t("ocr.attachments_table.size")',
                  align='right',
                  :show-overflow-tooltip='true',
                  :formatter='formatterKBSize',
                  sortable='')
                ods-table-column(
                  prop='compressedSize',
                  :label='$t("ocr.attachments_table.compressed_size")',
                  align='right',
                  :show-overflow-tooltip='true',
                  :formatter='formatterKBSize',
                  sortable='')
                ods-table-column(
                  prop='creationDate',
                  :label='$t("ocr.attachments_table.creation_date")',
                  align='center',
                  :show-overflow-tooltip='true',
                  :formatter='formatterDateTime',
                  sortable='')
                ods-table-column(
                  width='80')
                  template(slot-scope='scope')
                    ods-button.first-button(
                      type='neutral',
                      @click='downloadOcrAttachment')
                      ods-icon(name='download', size='16')
              //- ods-tooltip(:content='$t("party_detail.buttons.add_contact_data")', placement='bottom')
                ods-button.button-collapse(
                  icon='ods-icon-plus',
                  size='small',
                  circle,
                  @click.native='showDialogAddApprovalLevel()')
                  | {{ $t('party_detail.buttons.add_contact_data') }}
        //- Dialogo Rechazo de factura
        ods-dialog(
          ref='dialogRejectedInvoice',
          :title='$t("pendingtask.pendingtask_detail.rejectedinvoice.title")',
          :visible.sync='isShowDialogRejectedInvoice',
          @close='handleCloseDialogRejected',
          width='30%')
          ods-form(
            ref='formDialogRejectedInvoiceForm',
            :model='dialogRejectedInvoiceForm',
            :rules='rulesDialogRejectedInvoice')
            ods-form-item(
              :label='$t("pendingtask.pendingtask_detail.rejectedinvoice.motive")',
              size='mini',
              prop='motive')
              ods-input(
                :placeholder='$t("pendingtask.pendingtask_detail.rejectedinvoice.motive")',
                v-model='dialogRejectedInvoiceForm.motive')

          span.dialog-footer(slot='footer')
            ods-button(
              type='primary',
              @click.native="sendDocument('REJECT')")
              | {{ $t('buttons.btnOk') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import B2bTimeline from '@/components/B2bTimeline'
import Utils from '@/components/shared/Utils'
import PDFViewer from 'pdf-viewer-vue/dist/vue2-pdf-viewer' // En Vue 3: import PDFViewer from 'pdf-viewer-vue'
import router from '@/router/index'
import moment from 'moment'

export default {
  name: 'b2b-page-ocr-document',
  mixins: [Utils],
  data () {
    return {
      pdfDocument: null,
      activateModuleAttachment: ['0', '1'], // Módulos de la vista colapsables
      invoiceType_ocrValue: null,
      ocrDocumentForm: {
        id: null,
        documentName: null,
        emailFrom: null,
        statusDocument: null,
        projectName: null,
        idProject: null,
        mailServer: null,
        documentType: null,
        messageStatus: null,
        creationDateTime: null,
        ocrProcessDate: null,
        // Datos procesados por el OCR:
        currency: null,
        deliveryDate: null,
        dueDate: null,
        invoiceDate: null,
        invoiceNumber: null,
        invoiceSeriesCode: null,
        invoiceType: null,
        netAmount: null,
        purchaseOrder: null,
        receiverEmail: null,
        receiverName: null,
        receiverTaxId: null,
        receiverAddress: null,
        supplierEmail: null,
        supplierIban: null,
        supplierName: null,
        supplierTaxId: null,
        supplierAddress: null,
        totalAmount: null,
        totalTaxAmount: null,
        withAttachment: null,
        correctiveInvoiceId: null,
        buyerCentreCode: null,
        user: null,
        lockedAt: null,
        isLocked: false
      },
      ocrDocumentFormCopy: {}, // mantiene una copia original de los datos para reseteo de formulario
      // Pop-up rechazo de factura
      isShowDialogRejectedInvoice: false,
      // Formulario de rechazo de factura
      dialogRejectedInvoiceForm: {
        // Motivo del rechazo
        motive: null
      },
      // Validaciones
      ocrDocumentFormRules: {
        invoiceNumber: [ // 'Número de factura',
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 60,
            message: this.$t('msg_generics.max_num_character', { max: 60 }),
            trigger: 'change'
          }
        ],
        invoiceSeriesCode: [ // 'nº de serie de la factura',
          {
            max: 20,
            message: this.$t('msg_generics.max_num_character', { max: 20 }),
            trigger: 'change'
          }
        ],
        correctiveInvoiceId: [ // 'Número de factura rectificativa',
          {
            max: 60,
            message: this.$t('msg_generics.max_num_character', { max: 60 }),
            trigger: 'change'
          }
        ],
        purchaseOrder: [ // 'Pedido a nivel general',
          {
            max: 10,
            message: this.$t('msg_generics.max_num_character', { max: 10 }),
            trigger: 'change'
          }
        ],
        invoiceDate: [ // 'Fecha factura',
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        invoiceType: [ // 'Tipo de factura',
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ],
        receiverTaxId: [ // 'CIF receptor',
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 16,
            message: this.$t('msg_generics.max_num_character', { max: 16 }),
            trigger: 'change'
          }
        ],
        receiverName: [ // 'Nombre receptor',
          {
            max: 150,
            message: this.$t('msg_generics.max_num_character', { max: 150 }),
            trigger: 'change'
          }
        ],
        receiverAddress: [ // 'Dirección receptor',
          {
            max: 255,
            message: this.$t('msg_generics.max_num_character', { max: 255 }),
            trigger: 'change'
          }
        ],
        buyerCentreCode: [ // 'Código centro comprador',
          {
            max: 30,
            message: this.$t('msg_generics.max_num_character', { max: 30 }),
            trigger: 'change'
          }
        ],
        supplierTaxId: [ // 'CIF proveedor',
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            max: 16,
            message: this.$t('msg_generics.max_num_character', { max: 16 }),
            trigger: 'change'
          }
        ],
        supplierName: [ // 'Nombre proveedor',
          {
            max: 150,
            message: this.$t('msg_generics.max_num_character', { max: 150 }),
            trigger: 'change'
          }
        ],
        supplierAddress: [ // 'Dirección proveedor',
          {
            max: 255,
            message: this.$t('msg_generics.max_num_character', { max: 255 }),
            trigger: 'change'
          }
        ],
        supplierIban: [ // 'IBAN proveedor',
          {
            max: 255,
            message: this.$t('msg_generics.max_num_character', { max: 255 }),
            trigger: 'change'
          }
        ],
        supplierEmail: [ // 'Email proveedor',
          {
            max: 255,
            message: this.$t('msg_generics.max_num_character', { max: 255 }),
            trigger: 'change'
          }
        ],
        netAmount: [ // 'Base imponible',
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            pattern: /^-?\d+(\.\d+)?$/, // permitimos números decimales y negativos
            message: this.$t('msg_generics.number_required'),
            trigger: 'change'
          }
        ],
        totalTaxAmount: [ // 'Total impuestos',
          {
            pattern: /^-?\d+(\.\d+)?$/, // permitimos números decimales y negativos
            message: this.$t('msg_generics.number_required'),
            trigger: 'change'
          }
        ],
        totalAmount: [ // 'Total factura',
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          },
          {
            pattern: /^-?\d+(\.\d+)?$/, // permitimos números decimales y negativos
            message: this.$t('msg_generics.number_required'),
            trigger: 'change'
          }
        ],
        currency: [ // 'Divisa',
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'change'
          }
        ]
      },
      // Validaciones del formulario de rechazo de factura
      rulesDialogRejectedInvoice: {
        motive: [
          {
            required: true,
            message: this.$t(
              'pendingtask.pendingtask_detail.rejectedinvoice.motive_required'
            ),
            trigger: 'change'
          },
          {
            max: 1000,
            message: this.$t('validations.maxlenght', { maxlenght: 1000 }),
            trigger: 'change'
          }
        ]
      },

      // OPCIONES DE LOS CAMPOS SELECCIONABLES:
      optionsCurrency: [], // lista de divisas
      optionsDocumentTypes: [ // lista de tipos de documento
        {
          id: 'ORIGINAL',
          type: 'ORIGINAL'
        },
        {
          id: 'REPLACE',
          type: 'RECTIFICATIVA'
        }
      ],
      optionsInvoiceLineTax: [ // lista de tasas/impuestos
        {
          id: 'VAT',
          categoryCode: 'VAT'
        },
        {
          id: 'IGIC',
          categoryCode: 'IGIC'
        },
        {
          id: 'IPSI',
          categoryCode: 'IPSI'
        },
        {
          id: 'EXT',
          categoryCode: 'EXT'
        },
        {
          id: 'IRPF',
          categoryCode: 'IRPF'
        }
      ],
      optionsUnitsOfMeasure: [], // lista de unidades de medida de las líneas de factura

      dataOcrAttachment: [], // lista de adjuntos de ocr_document_email_attachment
      dataOcrLines: [], // lista de líneas de ocr_document_line
      dataOcrTaxes: [], // lista de impuestos/tasas de ocr_document_tax
      currentRowOcrLine: {}, // fila seleccionada en la tabla de líneas del documento
      currentRowOcrTax: {}, // fila seleccionada en la tabla de impuestos/tasas del documento
      currentRowOcrAttachment: {}, // fila seleccionada, para la descarga del adjunto seleccionado

      addApprovalLevelForm: {
        id: null,
        level: null,
        user: null,
        notification: null
      },

      rulesAddApprovalLevelForm: {
        level: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'submit'
          }
        ],
        user: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'submit'
          }
        ],
        notification: [
          {
            required: true,
            message: this.$t('msg_generics.field_required'),
            trigger: 'submit'
          }
        ]
      }
    }
  },

  components: {
    PDFViewer,
    B2bTimeline
  },

  computed: {
    ...mapGetters([
      'optionsFilterMediaType',
      'countries',
      'canAdminIndra'
    ])
  },

  watch: {
    '$route.params.documentId': {
      handler (newDocumentId) {
        if (newDocumentId) {
          this.loadOcrDataOnChangeDocument()
        }
      }
    }
  },

  methods: {
    ...mapActions([
      'getOcrDocuments', // Consulta de documentos OCR
      'getOcrDocument', // Consulta de datos de ocr_document
      'getOcrDocumentAttachment', // Consulta de datos de ocr_document_email_attachment
      'getOcrDocumentLines', // Consulta de líneas de ocr_document_line
      'getOcrDocumentTaxes', // Consulta de impuestos/tasas de ocr_document_tax
      'downloadOcrDocumentAttachment', // Descarga de un adjunto de ocr_document_email_attachment
      'sendOcrDocument', // Aprobar/rechazar documento OCR tras validación

      // Carga de opciones en los selects:
      'getOptionsFilterCurrency', // Consulta de divisas para cargar en el select
      'getOptionsUnitsOfMeasure' // Consulta de unidades de medida para cargar en el select
    ]),

    /* Formatear columna: Fecha */
    formatterDateTime (row, column) {
      const dateValue = row[column.property]
      if (moment(dateValue).isValid()) {
        const date = moment(dateValue)
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    // Formateo a KB
    formatterKBSize (row, column) {
      const number = row[column.property] / 1024
      return this.$n(Math.round(number * 100) / 100, 'decimal') + '  KB'
    },

    // Formateo de tipo de documento
    formatterType (docType) {
      if (docType.type === null && docType.description) {
        return docType.description
      } else if (docType.type) {
        return this.$t('invoice_document_type.' + docType.type)
      }
    },

    // Formateo de números
    onNumberInput (row, prop) {
      let value = row[prop]
      console.log('Initial value:', value)

      // Por defecto:
      if (value === undefined || value === null || value === '') {
        row[prop] = null // Valor por defecto si la cadena está vacía
        console.log('Formatted value by default:', row[prop])
        return
      }

      if (typeof value === 'string') {
        // Eliminar el símbolo '%' si está presente (para la tasa de impuestos)
        if (value.endsWith('%')) {
          value = value.slice(0, -1)
        }

        // Elimina espacios
        value = value.trim().replace(/\s+/g, '')
        if (value.includes(',') && value.includes('.')) {
          const lastComma = value.lastIndexOf(',')
          const lastDot = value.lastIndexOf('.')
          if (lastComma > lastDot) {
            // Formato europeo: 1.234,56
            value = value.replace(/\./g, '')
            value = value.replace(/,/g, '.')
          } else {
            // Formato inglés: 1,234.56
            value = value.replace(/,/g, '')
          }
        } else if (value.includes(',')) {
          const count = (value.match(/,/g) || []).length
          if (count > 1) {
            // Ej: 1,234,567 (probablemente miles)
            value = value.replace(/,/g, '')
          } else {
            // Ej: 1234,56 (probablemente decimal)
            value = value.replace(/,/g, '.')
          }
        } else if (value.includes('.')) {
          // const originalValue = value // Guardamos el valor original para notificar al usuario si es necesario
          const count = (value.match(/\./g) || []).length
          if (count > 1) {
            // Ej: 1.234.567 (probablemente miles)
            value = value.replace(/\./g, '')
          }
          // Si solo hay un punto, se asume que es el separador decimal y se deja como está
        }
        // Si no hay ni punto ni coma, se deja igual

        // Limitar al número de cifras decimales máximo permitido (8)
        const numCifrasDecimales = Math.min((value.toString().split('.')[1] || '').length, 8)
        // Convertir a número flotante
        const numericValue = parseFloat(value)
        row[prop] = isNaN(numericValue) ? null : numericValue.toFixed(numCifrasDecimales) // Redondeo
      } else if (typeof value === 'number') {
        // Limitar al número de cifras decimales máximo permitido (8)
        const numCifrasDecimales = Math.min((value.toString().split('.')[1] || '').length, 8)
        row[prop] = value.toFixed(numCifrasDecimales) // Redondeo
      } else {
        row[prop] = null // Valor por defecto si no es numérico
      }
      console.log('Formatted value:', row[prop])
    },

    formatTaxRate (value) {
      if (typeof value === 'string') {
        // Eliminar el símbolo '%' si está presente
        if (value.endsWith('%')) {
          value = value.slice(0, -1)
        }
        // Convertir a número flotante
        const numericValue = parseFloat(value)
        return isNaN(numericValue) ? 0 : numericValue.toFixed(2) // Limitar a 2 decimales
      } else if (typeof value === 'number') {
        return value.toFixed(2) // Limitar a 2 decimales
      }
      return 0 // Valor por defecto si no es numérico
    },

    // Acción de añadir una línea al documento OCR
    addOcrDocumentLine () {
      this.dataOcrLines.push({
        id: null,
        productCode: null,
        amount: null,
        description: null,
        quantity: null,
        unit: this.optionsUnitsOfMeasure.find(unit => unit.code === 'UND')?.id || null,
        unitPrice: null,
        purchaseOrder: null
      })
      console.log('dataOcrLines tras insertar línea: ', this.dataOcrLines)
    },

    // Acción de eliminar una línea del documento OCR
    removeOcrDocumentLine (row) {
      const index = this.dataOcrLines.indexOf(row)
      if (index !== -1) {
        this.dataOcrLines.splice(index, 1)
      }
      console.log('dataOcrLines tras eliminar línea: ', this.dataOcrLines)
    },

    // Acción de añadir un impuesto/tasa al documento OCR
    addOcrDocumentTax () {
      this.dataOcrTaxes.push({
        id: null,
        amount: null,
        categoryCode: this.optionsInvoiceLineTax.find(tax => tax.categoryCode === 'VAT')?.id || null,
        taxAmount: null,
        taxRate: null
      })
      console.log('dataOcrTaxes tras insertar impuesto/tasa: ', this.dataOcrTaxes)
    },

    // Acción de eliminar un impuesto/tasa del documento OCR
    removeOcrDocumentTax (row) {
      const index = this.dataOcrTaxes.indexOf(row)
      if (index !== -1) {
        this.dataOcrTaxes.splice(index, 1)
      }
      console.log('dataOcrTaxes tras eliminar impuesto/tasa: ', this.dataOcrTaxes)
    },

    // Descarga de un adjunto
    async downloadOcrAttachment () {
      const load = this.$loading({
        lock: true,
        text: this.$t('invoice_detail.load.download_attachment')
      })
      try {
        const filename = await this.downloadOcrDocumentAttachment({
          attachmentId: this.currentRowOcrAttachment.id
        })
        this.$notify({
          title: this.$t('msg_generics.download_file_ok', { filename: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        console.log('downloadOcrAttachment CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    // Reseteo al cerrar dialogo
    handleCloseDialogRejected () {
      this.$refs.formDialogRejectedInvoiceForm.resetFields()
    },

    async getOcrDocumentOnDatabase () {
      // Get datos de ocr_document
      try {
        console.log('documentId on route.params: ', this.$route.params.documentId)
        console.log('projectName on route.params: ', this.$route.params.projectName)
        if (this.$route.params.documentId !== null && this.$route.params.projectName !== undefined) {
          const data = await this.getOcrDocument({ documentId: this.$route.params.documentId, projectName: this.$route.params.projectName })
          this.ocrDocumentForm = data
          this.ocrDocumentFormCopy = data // guardamos una copia para reseteo de datos iniciales
          this.pdfDocument = 'data:application/pdf;base64,' + data.pdfBase64
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // Aprobación/Rechazo del documento OCR tras validación de datos por el usuario
    async sendDocument (action) {
      let messageConfirm = ''
      let messageLoading = ''
      let messageNotify = ''
      if (action === 'APPROVE') {
        this.$refs.ocrDocumentForm.validate(async (valid) => { // validar formulario
          if (valid) {
            // if (action === 'APPROVE') {
            messageConfirm = this.$t('ocr.send_ocr_document.confirm.title_approve')
            messageLoading = this.$t('ocr.send_ocr_document.confirm.approving')
            messageNotify = this.$t('ocr.send_ocr_document.confirm.approve_notification')
            // Mostrar el diálogo de confirmación solo para la acción "APPROVE"
            this.$confirm(messageConfirm, {
              confirmButtonText: this.$t('ocr.send_ocr_document.confirm.confirm_button_send_document'),
              showCancelButton: false,
              center: true,
              iconClass: 'ods-icon-warning'
            }).then(async () => {
              await this.processDocument(action, messageLoading, messageNotify)
            }).catch(() => {})
          } else {
            this.isShowDialogRejectedInvoice = false
            this.$notify({
              title: this.$t('ocr.send_ocr_document.confirm.form_notification_error'),
              type: 'error',
              position: 'top-right',
              customClass: 'b2b-notification-warning',
              duration: 10000
            })
          }
        })
      } else if (action === 'REJECT') {
        messageLoading = this.$t('ocr.send_ocr_document.confirm.rejecting')
        messageNotify = this.$t('ocr.send_ocr_document.confirm.reject_notification')
        // Procesar el rechazo si la validación es exitosa
        await this.processDocument(action, messageLoading, messageNotify)
      }
    },

    // Procesa el documento OCR y lo envía al servidor para su aprobación o rechazo
    async processDocument (action, messageLoading, messageNotify) {
      const load = this.$loading({
        lock: true,
        text: messageLoading
      })
      try {
        const data = this.ocrDocumentForm
        data.invoiceDate = moment(data.invoiceDate).isValid() ? moment(data.invoiceDate).format('YYYY-MM-DD') : null
        data.deliveryDate = moment(data.deliveryDate).isValid() ? moment(data.deliveryDate).format('YYYY-MM-DD') : null
        data.taxes = this.dataOcrTaxes // Impuestos/tasas
        data.lines = this.dataOcrLines // Líneas de factura
        data.action = action // Acción a realizar: 'APPROVE' o 'REJECT'
        data.rejectMotive = this.dialogRejectedInvoiceForm.motive // Motivo de rechazo
        const returnOk = await this.sendOcrDocument(data)
        if (returnOk) {
          this.$notify({
            title: messageNotify,
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
          // Búscamos el siguiente documento OCR pendiente de validar:
          const dataQuery = {
            query: { projectId: this.ocrDocumentForm.idProject, sort: 'id,ASC', page: 0, size: 1, lookingNextDocument: true }
          }
          const ocrDocuments = await this.getOcrDocuments(dataQuery)
          if (ocrDocuments && ocrDocuments.data && ocrDocuments.data.content && ocrDocuments.data.content.length > 0) {
            load.text = this.$t('ocr.send_ocr_document.confirm.loading_next_document')
            const nextOcrDocument = ocrDocuments.data.content[0]
            // Redirigimos al siguiente documento OCR pendiente de validar:
            router.push({
              name: 'page-ocr-document',
              params: {
                documentId: nextOcrDocument.id,
                documentName: nextOcrDocument.documentName,
                projectName: nextOcrDocument.projectName
              }
            })
          } else {
            // Redirigimos a la tabla de documentos OCR si no hay más documentos pendientes
            router.push({ name: 'documentos-ocr-table' })
          }
        }
      } catch (error) {
        console.log('sendDocument CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        this.isShowDialogRejectedInvoice = false
        load.close()
      }
    },

    async getOcrDocumentAttachmentOnDatabase () {
      // Get datos de ocr_document_email_attachment
      try {
        if (this.$route.params.documentId !== null && this.$route.params.documentId !== undefined) {
          const data = await this.getOcrDocumentAttachment({ documentId: this.$route.params.documentId })
          this.dataOcrAttachment = data
          console.log('getOcrDocumentAttachmentOnDatabase on charge: ', this.dataOcrAttachment)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async getOcrDocumentLinesOnDatabase () {
      // Get datos de ocr_document_line
      try {
        if (this.$route.params.documentId !== null && this.$route.params.documentId !== undefined) {
          const data = await this.getOcrDocumentLines({ documentId: this.$route.params.documentId })
          this.dataOcrLines = data
          // Formatear los valores numéricos al cargar los datos
          this.dataOcrLines.forEach(line => {
            this.onNumberInput(line, 'quantity')
            this.onNumberInput(line, 'unitPrice')
            this.onNumberInput(line, 'amount')
          })
          console.log('getOcrDocumentLinesOnDatabase on charge: ', this.dataOcrLines)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    async getOcrDocumentTaxesOnDatabase () {
      // Get datos de ocr_document_tax
      try {
        if (this.$route.params.documentId !== null && this.$route.params.documentId !== undefined) {
          const data = await this.getOcrDocumentTaxes({ documentId: this.$route.params.documentId })
          // Formatear los valores de taxRate al cargar los datos
          this.dataOcrTaxes = data.map(tax => {
            tax.taxRate = this.formatTaxRate(tax.taxRate)
            return tax
          })
          // Formatear los valores numéricos al cargar los datos
          this.dataOcrTaxes.forEach(tax => {
            this.onNumberInput(tax, 'amount')
            this.onNumberInput(tax, 'taxRate')
            this.onNumberInput(tax, 'taxAmount')
          })
          console.log('getOcrDocumentTaxesOnDatabase on charge: ', this.dataOcrTaxes)
        }
      } catch (error) {
        this.getNotificationErrorMessage(error)
      }
    },

    // EVENTOS DE TABLAS PARA GESTIONAR LA FILA SELECCIONADA
    handleCellMouseEnterOcrAttachment (row, column, cell, event) {
      this.currentRowOcrAttachment = row
    },
    handleCellMouseEnterOcrLine (row, column, cell, event) {
      this.currentRowOcrLine = row
    },
    handleCellMouseEnterOcrTax (row, column, cell, event) {
      this.currentRowOcrTax = row
    },

    // Limpia los datos del formulario
    async cancelOcrDocumentForm () {
      const load = this.$loading({
        lock: true,
        text: this.$t('project_detail.load.cancel')
      })
      try {
        // Quitamos el foco del boton
        this.$refs.buttonCancel.$el.blur()
        // Reseteamos
        this.ocrDocumentForm = this.ocrDocumentFormCopy
        this.$refs.ocrDocumentForm.clearValidate()
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    configureCurrency () {
      // Verificar si el valor de currency es similar a algún código o símbolo en optionsCurrency, en cuyo caso se marcará la opción correspondiente en el combo
      const currencyMatch = this.optionsCurrency.find(currency => {
        const currencyCode = currency.code?.toLowerCase() || ''
        const currencySymbol = currency.symbol?.toLowerCase() || ''
        const formCurrency = this.ocrDocumentForm.currency?.toLowerCase() || ''

        return currencyCode.includes(formCurrency) || currencySymbol.includes(formCurrency) || formCurrency.includes(currencyCode) || formCurrency.includes(currencySymbol)
      })
      if (currencyMatch) {
        this.ocrDocumentForm.currency = currencyMatch.id // Marcar la opción correspondiente en el combo
      } else { // en caso contrario, se pone euro como divisa seleccionada por defecto
        this.ocrDocumentForm.currency = this.optionsCurrency.find(
          currency => currency.code.toLowerCase() === 'eur'
        )?.id || null
      }
    },

    configureUnitOfMeasure () {
      // Verificar si el valor de unit en cada línea coincide con los términos especificados
      this.dataOcrLines.forEach(line => {
        const unitMatch = this.optionsUnitsOfMeasure.find(unit => {
          const unitCode = unit.code?.toLowerCase() || ''
          const unitDescription = unit.description?.toLowerCase() || ''
          const lineUnit = line.unit?.toLowerCase() || ''

          return unitCode.includes(lineUnit) || unitDescription.includes(lineUnit) || lineUnit.includes(unitCode) || lineUnit.includes(unitDescription)
        })
        if (unitMatch) {
          line.unit = unitMatch.id // Marcar la opción correspondiente en el combo
        } else { // en caso contrario, se pone 'unidades' como unidad de medida seleccionada por defecto
          line.unit = this.optionsUnitsOfMeasure.find(
            unit => unit.code.toLowerCase() === 'und'
          )?.id || null
        }
        console.log('Valor asignado a line.unit:', line.unit)
      })
    },

    configureTaxes () {
      // Verificar si el valor de tasas/impuestos coincide con los términos especificados
      this.dataOcrTaxes.forEach(tax => {
        const taxMatch = this.optionsInvoiceLineTax.find(tasa => {
          const categoryCode = tasa.categoryCode?.toLowerCase() || ''
          const taxCategoryCode = tax.categoryCode?.toLowerCase().replace(/[^\w\s]/gi, '') || '' // texto en minúsculas y sin símbolos de puntuación

          return categoryCode.includes(taxCategoryCode) || taxCategoryCode.includes(categoryCode) || taxCategoryCode.includes('iva')
        })
        if (taxMatch) {
          console.log('entro en taxMatch para tasa: ', taxMatch.categoryCode, ' con id: ', taxMatch.id)
          tax.categoryCode = taxMatch.id // Marcar la opción correspondiente en el combo
        } else { // en caso contrario, se pone tipo VAT seleccionado por defecto
          tax.categoryCode = this.optionsInvoiceLineTax.find(
            type => type.categoryCode.toLowerCase() === 'vat'
          )?.id || null
        }
        console.log('Valor asignado a tax.categoryCode:', tax.categoryCode)
      })
    },

    configureInvoiceType () {
      console.log('>>>> Entro en configureInvoiceType')
      this.invoiceType_ocrValue = this.ocrDocumentForm.invoiceType || '-' // para mostrar en el tooltip, guión en caso de no tener valor
      // Verificar si el valor de invoiceType coincide con los términos especificados
      const invoiceType = this.ocrDocumentForm.invoiceType?.toLowerCase()
      const keywords = ['rappel', 'rectif', 'correcti', 'credit', 'debit', 'abono', 'cargo', 'manual']
      if (keywords.some(keyword => invoiceType?.includes(keyword))) {
        this.ocrDocumentForm.invoiceType = this.optionsDocumentTypes.find(
          type => type.type.toLowerCase() === 'rectificativa'
        )?.id || null
      } else { // en caso contrario, se considera como original por defecto
        this.ocrDocumentForm.invoiceType = this.optionsDocumentTypes.find(
          type => type.type.toLowerCase() === 'original'
        )?.id || null
      }
    },

    async loadOcrDataOnChangeDocument () {
      const load = this.$loading({
        lock: true,
        text: this.$t('centres.load.text_load_init_data')
      })
      try {
        await this.loadInitOcrData()
      } catch (error) {
        console.log('created CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
        this.$notify({
          title: this.$t('ocr.send_ocr_document.confirm.nextDocumentInfo'),
          type: 'info',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
      }
    },

    async loadInitOcrData () {
      console.log(' >>> Entro en loadInitData')
      // Get datos de adjuntos de ocr_document_email_attachment
      this.getOcrDocumentAttachmentOnDatabase()
      // Get datos de líneas de ocr_document_line
      this.getOcrDocumentLinesOnDatabase()
      // Get datos de impuestos/tasas de ocr_document_tax
      this.getOcrDocumentTaxesOnDatabase()
      // Get datos del ocr_document
      await this.getOcrDocumentOnDatabase()

      // Cargamos las divisas para el select
      this.optionsCurrency = await this.getOptionsFilterCurrency()
      console.log('optionsCurrency: ', this.optionsCurrency)
      this.configureCurrency()

      // Cargamos las unidades de medida para el select
      this.optionsUnitsOfMeasure = await this.getOptionsUnitsOfMeasure()
      this.configureUnitOfMeasure()

      this.configureTaxes()
      this.configureInvoiceType()
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = error.data.message
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error, 30000)
    }
  },

  loadInfo () {

  },

  async mounted () {
    // wait for DOM to finish rendering
    await this.$nextTick()
    // corrección bug 'default zoom setting not working' al cargar el visualizador de pdf
    const pdfViewer = this.$refs.pdfViewer
    this.$watch(() => pdfViewer.zoom, () => {
      const zoom = pdfViewer.zoom
      pdfViewer.zoom = zoom
    }, { deep: true })
    // establecemos el zoom por defecto del visualizador de pdf
    pdfViewer.zoom = 175
  },

  async created () {
    console.log('Componente B2bPageOcrDocument creado para documento con id: ', this.$route.params.documentId)
    const load = this.$loading({
      lock: true,
      text: this.$t('centres.load.text_load_init_data')
    })
    try {
      await this.loadInitOcrData()
    } catch (error) {
      console.log('created CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}
</script>

  <style lang="scss" scoped>
  .b2b-page-ocr-document {
    padding: 40px 40px 40px 40px;

    .margin-bottom {
      margin-bottom: 20px;
    }

    ::v-deep .ods-form-item {
      .ods-form-item__error {
        position: relative; // Ajustamos la posición del mensaje de error para evitar solapamientos
      }
    }

    ::v-deep .dialog-footer {
      height: 30px; // Aumenta la altura del footer
      display: flex; // Asegura la alineación de los elementos
      align-items: center; // Centra verticalmente los botones
      justify-content: flex-end; // Alinea los botones a la derecha
    }

    ::v-deep .ods-module{
      &__header{
        background-color: var(--color-bg-hover-2);
        padding: 0px;
        .info{
          margin-left: 40px;
          margin-right: 40px;
          height: 72px;
          color: var(--color-bg-interactive);
          size: 16px;
          line-height: 24px;
        }
      }

      &__body{
        padding: 32px;
        .info{
          padding-bottom: 32px;
        }
        .form-standard{
          margin: 1px;
        }
        .form-middle{
          margin-top: 1px;
          margin-bottom: 1px;
          margin-left: 20px;
          margin-right: 20px;
        }
        .form-center-left{
          margin-top: 1px;
          margin-bottom: 1px;
          margin-left: 20px;
          margin-right: 10px;
        }
        .form-center-right{
          margin-top: 1px;
          margin-bottom: 1px;
          margin-left: 10px;
          margin-right: 20px;
        }
        .form-title{
          margin-top: 10px;
          margin-bottom: 5px;
          margin-left: 1px;
          font-weight: bold;
        }
        .label-info{
          font-size: 15px;
          color: red;
          margin-bottom: 10px;
          // Centrado del texto horizontal y vertical
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
        }
        .leftColumn_pdf_viewer{
          padding-right: 10px;
        }
        .rightColumn_data{
          padding-left: 10px;
        }
      }
    }

    .form-actions{
      padding-top: 40px;
      padding-bottom: 40px;
      .ods-button{
        float: right;
      }
    }

    .collapse{
      margin-top: 10px;
      .info {
        margin-left: 1rem;
        color: var(--color-txt-secondary);
      }

      ::v-deep .ods-table{
        th {
          padding: rem(0);
          padding-top: rem(4);

          .cell {
            font-weight: 500;
          }
        }
        &__row{
          .ods-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: 0px;
            i {
              margin-left: 0px;
            }
          }
          .first-button {
            padding: 0px;
            margin-left: 0px;
            margin-right: rem(12);
            i {
              margin-left: 0px;
            }
          }
        }
      }

      .button-collapse {
        float: right;
        margin-top: 1rem;
      }
      .button-add-tax {
        float: right;
      }

      ::v-deep .ods-module{
        &__body{
          padding: 0px;
        }
      }
    }  ::v-deep .ods-form-item.hidden label.ods-form-item__label {
      color: transparent !important;
    }
    ::v-deep .ods-form-item.hidden .ods-input.is-disabled .ods-input__inner {
      background-color: transparent !important;
      border-color: transparent !important;
    }
  }
</style>
